export default __webpack_public_path__ + "static/media/linux.908c1b40.svg";